<template>
  <div>
    <div id="Gmaps"></div>
    <remote-js
      jsUrl="https://maps.googleapis.com/maps/api/js?key=AIzaSyB6ocCOSA_6fQiOiMUZAJKKv66sq7yksK8&libraries=places&language=en&sessiontoken =61654819d5215"
      :js-load-call-back="initAutocomplete"
    ></remote-js>
  </div>
</template>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB6ocCOSA_6fQiOiMUZAJKKv66sq7yksK8&libraries=places&language=en&callback=initAutocomplete&sessiontoken =61654819d5215"></script>
<script>
// import RemoteJs from "../../api/remote";
import RemoteJs from "./Remote";
export default {
  components: { RemoteJs },
  props: {
    mapData: {
      type: Object,
      required: true,
    },
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    return {
      autocomplete: "",
      companyauto: "",
      componentForm: {
        // address: "short_name",
        street_number: "long_name",
        route: "long_name",
        locality: "long_name",
        postal_code: "long_name",
        administrative_area_level_2: "long_name",
      },
      form: {
        // firstName: "1",
        // lastName: "1",
        // email: "1",
        // mobile: "1",
        // password2: "1",
        // password: "1",
        tag: "",
        address: "",
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        postal_code: "short_name",
        // administrative_area_level_1:"short_name",
        administrative_area_level_2: "short_name",
      },
    };
  },
  watch: {
    form: {
      handler(newValue, oldValue) {
        // console.log(newValue);
        this.$emit("fun", newValue);
      },
      deep: true,
    },
  },
  methods: {
    initAutocomplete() {
      // Create the autocomplete object, restricting the search to geographical
      // location types.
      // console.log(this.offsetwidth)

      this.autocompletepc = new google.maps.places.Autocomplete(
        /** @type  {!HTMLInputElement} */ (
          document.getElementById("autocompletepc")
        ),
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );
      this.autocompletepc2 = new google.maps.places.Autocomplete(
        /** @type  {!HTMLInputElement} */ (
          document.getElementById("autocompletepc2")
        ),
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );
      this.autocompletepc3 = new google.maps.places.Autocomplete(
        /** @type  {!HTMLInputElement} */ (
          document.getElementById("autocompletepc3")
        ),
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );
      this.autocompleteh5 = new google.maps.places.Autocomplete(
        /** @type  {!HTMLInputElement} */ (
          document.getElementById("autocompleteh5")
        ),
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );
      this.autocompleteh52 = new google.maps.places.Autocomplete(
        /** @type  {!HTMLInputElement} */ (
          document.getElementById("autocompleteh52")
        ),
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );
      this.autocompleteh53 = new google.maps.places.Autocomplete(
        /** @type  {!HTMLInputElement} */ (
          document.getElementById("autocompleteh53")
        ),
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );

      // console.log(this.autocomplete, document.getElementById("autocomplete"));
      // When the user selects an address from the dropdown, populate the address
      // fields in the form.
      this.autocompletepc.addListener("place_changed", this.fillInAddress);
      this.autocompletepc2.addListener("place_changed", this.fillInAddress);
      this.autocompletepc3.addListener("place_changed", this.fillInAddress);
      this.autocompleteh5.addListener("place_changed", this.fillInAddress);
      this.autocompleteh52.addListener("place_changed", this.fillInAddress);
      this.autocompleteh53.addListener("place_changed", this.fillInAddress);
    },
    fillInAddress() {
      // Get the place details from the autocomplete object.
      var placepc = this.autocompletepc.getPlace();
      var placepc2 = this.autocompletepc2.getPlace();
      var placepc3 = this.autocompletepc3.getPlace();
      var placeh5 = this.autocompleteh5.getPlace();
      var placeh52 = this.autocompleteh52.getPlace();
      var placeh53 = this.autocompleteh53.getPlace();
      // for (var component in this.componentForm) {
      //   // document.getElementById(component).value = "";
      //   // document.getElementById(component).disabled = false;
      //   // console.log(document.getElementById(component), component);
      //   // this.form[component] = "";
      //   if(component!="city"){
      //     document.getElementById(component).disabled = true;
      //   }
      // }
      // for(let i=0;i<this.componentForm.length;i++){
      //   this.form[i]=
      // }
      // // Get each component of the address from the place details
      // and fill the corresponding field on the form.
      if (placepc !== undefined) {
        for (var i = 0; i < placepc.address_components.length; i++) {
          var addressType = placepc.address_components[i].types[0];
          // console.log(this.form[addressType]+1,addressType);
          if (this.form[addressType]) {
            var val =
              placepc.address_components[i][this.componentForm[addressType]];
            // document.getElementById(addressType).value = val;
            this.form[addressType] = val;
          }
        }
        this.form.address = placepc.formatted_address;
        this.form.tag = "placepc";
      }
      if (placepc2 !== undefined) {
        for (var i = 0; i < placepc2.address_components.length; i++) {
          var addressType = placepc2.address_components[i].types[0];
          // console.log(this.form[addressType]+1,addressType);
          if (this.form[addressType]) {
            var val =
              placepc2.address_components[i][this.componentForm[addressType]];
            // document.getElementById(addressType).value = val;
            this.form[addressType] = val;
          }
        }
        this.form.address = placepc2.formatted_address;
        this.form.tag = "placepc2";
      }
      if (placepc3 !== undefined) {
        for (var i = 0; i < placepc3.address_components.length; i++) {
          var addressType = placepc3.address_components[i].types[0];
          // console.log(this.form[addressType]+1,addressType);
          if (this.form[addressType]) {
            var val =
              placepc3.address_components[i][this.componentForm[addressType]];
            // document.getElementById(addressType).value = val;
            this.form[addressType] = val;
          }
        }
        this.form.address = placepc3.formatted_address;
        this.form.tag = "placepc3";
      }
      if (placeh5 !== undefined) {
        for (var i = 0; i < placeh5.address_components.length; i++) {
          var addressType = placeh5.address_components[i].types[0];
          // console.log(this.form[addressType]+1,addressType);
          if (this.form[addressType]) {
            var val =
              placeh5.address_components[i][this.componentForm[addressType]];
            // document.getElementById(addressType).value = val;
            this.form[addressType] = val;
          }
        }
        this.form.address = placeh5.formatted_address;
        this.form.tag = "placeh5";
      }

      if (placeh52 !== undefined) {
        for (var i = 0; i < placeh52.address_components.length; i++) {
          var addressType = placeh52.address_components[i].types[0];
          // console.log(this.form[addressType]+1,addressType);
          if (this.form[addressType]) {
            var val =
              placeh52.address_components[i][this.componentForm[addressType]];
            // document.getElementById(addressType).value = val;
            this.form[addressType] = val;
          }
        }
        this.form.address = placeh52.formatted_address;
        this.form.tag = "placeh52";
      }
      if (placeh53 !== undefined) {
        for (var i = 0; i < placeh53.address_components.length; i++) {
          var addressType = placeh53.address_components[i].types[0];
          // console.log(this.form[addressType]+1,addressType);
          if (this.form[addressType]) {
            var val =
              placeh53.address_components[i][this.componentForm[addressType]];
            // document.getElementById(addressType).value = val;
            this.form[addressType] = val;
          }
        }
        this.form.address = placeh53.formatted_address;
        this.form.tag = "placeh53";
      }

      // console.log(this.form);
    },

    geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    loadRongJs() {
      // console.log(this.mapData)
      var options = {
        zoom: 15,
        // 1：世界
        // 5：大陆/大陆
        // 10：城市
        // 15：街道
        // 20：建筑物
        center: { lat: this.mapData.latitude, lng: this.mapData.longitude },
        // 动态从调用组件传递经纬度
        disableDefaultUI: false,
        zoomControl: true,
      };
      var map = new google.maps.Map(document.getElementById("Gmaps"), options);
      let marker = new google.maps.Marker({
        position: { lat: this.mapData.latitude, lng: this.mapData.longitude },
        map: map,
        title: "Google Map", // 鼠标悬浮显示
        // 此处的icon为标记的自定义图标
        // icon: 'http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        // animation:  google.maps.Animation.DROP,
        width: "20px",
        height: "20px",
      });
      marker.setMap(map);

      // 配置定位点鼠标点击显示内容 本文是父组件传过来的
      var infowindow = new google.maps.InfoWindow({
        content: this.mapData.address,
      });
      marker.addListener("click", function () {
        infowindow.open(map, marker);
      });
    },
  },
};
</script>
<style scoped>
#Gmaps {
  width: 100%;
  height: 28rem;
  border-radius: 5px;
}
</style>
